import { FORM_TYPE } from '@shared/enum';
import { FormModel } from '../model';

export const ATTACHMENT_FORM: FormModel[] = [
  {
    key: 'docType',
    type: FORM_TYPE.CONTROL,
    validation: [],
    value: null,
  },
  {
    key: 'attachments',
    type: FORM_TYPE.CONTROL,
    validation: [],
    value: '',
  },
];
